
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PortalDto } from 'src/app/aplication/api/Manipulate/PortalDto';
import { ProcessCreateDto, ProcessDto, ProcessUpdateStatusDto } from '../Manipulate/ProcessDto';
import { CommentCreateDto } from '../Manipulate/CommentDto';
import { OfferItemSoldDto } from '../Manipulate/OfferItem';
import { environment } from 'src/environments/environment';
import { UpdateResponsibleRequest } from '../Manipulate/Responsible';
@Injectable({
  providedIn: 'root'
})
export class ProcessosService {
  // private apiUrl = 'http://localhost:5000/api/process';
  // private apiUrlMin = 'http://localhost:5000';
  private apiUrl = environment.apiUrl +'/process';

  constructor(private http: HttpClient) { }
  public ListarProcessos() : Observable<ProcessDto[]>{
    return this.http.get<ProcessDto[]>(`${this.apiUrl}`);
  }
  public GetCommentsByProcessId(processId:string) : Observable<CommentCreateDto[]>{
    return this.http.get<CommentCreateDto[]>(`${this.apiUrl}/comments/${processId}`);
  }
  public ListProcessesByPeriod( from:string , to:string  ) : Observable<ProcessDto[]>{
    return this.http.get<ProcessDto[]>(`${this.apiUrl}/${from}/${to}`);
  }
  public GetProcessByDateRange(from?: string, to?:string): Observable<ProcessDto[]> {
    return this.http.get<ProcessDto[]>(`${this.apiUrl}/${from}/${to}`);
  }
  public AdicionarProcesso(newProcesso:FormData) : Observable<any>{
    return this.http.post(`${this.apiUrl}`, newProcesso);
  }
  public uploadFile(event: any) {
    const files = event.target.files;
    if (files.length === 0) return;
    const formData = new FormData();
    for (let file of files) {
      formData.append('anexos', file, file.name);
    }
    this.http.post('URL_PARA_ENVIAR_OS_ARQUIVOS', formData).subscribe(response => {
      //console.log(response);
    });
  }
  public AtualizarCompanyProcesso(processId: string, companyId:string):Observable<any> {
    return this.http.post(`${this.apiUrl}/updateCompany/${processId}/${companyId}`, '');
  }
  public UpdateResponsible(processId: string, responsibleId:string):Observable<any> {
    var responsibleUpdated = new UpdateResponsibleRequest();
    responsibleUpdated.responsibleId =responsibleId
    return this.http.post(`${this.apiUrl}/updateResponsible/${processId}`, responsibleUpdated);
  }
  public AtualizarStatusProcesso(processId: string, statusId:number):Observable<any> {
    return this.http.post(`${this.apiUrl}/updateStatus/${processId}/${statusId}`, '');
  }
  public ArquivarProcesso(processId: string, archived:boolean):Observable<any> {
    return this.http.post(`${this.apiUrl}/updateArchived/${processId}/${archived}`, '');
  }
  public FavoritarProcesso(processId: string, favorite:boolean):Observable<any> {
    return this.http.post(`${this.apiUrl}/updateFavorite/${processId}/${favorite}`, '');
  }
  public AdicionarComentario(processId: string, comment:CommentCreateDto):Observable<any> {
    return this.http.post(`${this.apiUrl}/updateComment/${processId}`, comment);
  }
  public RemoverComentario(commentId:string):Observable<any> {
    return this.http.delete(`${this.apiUrl}/removeComment/${commentId}`);
  }
  public GetById(id?: string): Observable<ProcessDto> {
    return this.http.get<ProcessDto>(`${this.apiUrl}/${id}`);
  }
  public GetMinimalById(id?: string): Observable<ProcessDto> {
    return this.http.get<ProcessDto>(`${this.apiUrl}/minimalById/${id}`);
  }
  public ListQuantitySellByProcess(id?: string): Observable<OfferItemSoldDto[]> {
    return this.http.get<OfferItemSoldDto[]>(`${this.apiUrl}/listQuantitySoldByProcessId/${id}`);
  }
  public GetByOfferId(offerId?: string): Observable<ProcessDto> {
    return this.http.get<ProcessDto>(`${this.apiUrl}/byOfferId/${offerId}`);
  }
  public Edit(dto: ProcessDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${dto.id}`, dto);
  }
  public Delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
  public ListByStatus(status?: number): Observable<ProcessDto[]> {
    return this.http.get<ProcessDto[]>(`${this.apiUrl}/byStatus/${status}`);
  }
  public ListArchiveds(): Observable<ProcessDto[]>{
    return this.http.get<ProcessDto[]>(`${this.apiUrl}/archiveds`);
  }
  public ListArchivedProcessesByPeriod( from:string , to:string  ) : Observable<ProcessDto[]>{
    return this.http.get<ProcessDto[]>(`${this.apiUrl}/archived/${from}/${to}`);
  }
}
